import { FC, PropsWithChildren } from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../redux/login';
import constants from 'src/services/constants';
import { useScopedPermissions } from '/features/permissions/useScopedPermissions';

type State = {
	login: {
		loggedin: boolean;
		token?: string;
		loggedinAsSupervisor: boolean;
		qrDetails: {
			orgId: number;
			timezone_name: string;
		};
	};
};

export const QRPreviewAuthGuard: FC<PropsWithChildren<any>> = (props) => {
	const dispatch = useDispatch();
	const location = useLocation();
	const { hasScope, isFetching } = useScopedPermissions();
	const authenticated = useSelector((state: State) => state.login.loggedin);
	const supervisor = useSelector((state: State) => state.login.loggedinAsSupervisor);
	const hasQRScope = hasScope([constants.SCOPE_USER_SUPERVISOR_QR]);

	if (isFetching) return null;

	// if user is not authenticated & not a supervisor, redirect to login page
	if (!authenticated && !supervisor) {
		dispatch(logout());
		return (
			<Redirect
				to={{
					pathname: '/',
					search: `?redirectTo=${location.pathname}${location.search ?? ''}`
				}}
			/>
		);
	}

	// if Supervisor login, redirect to qr preview page
	if (authenticated && supervisor && hasQRScope && location.pathname === '/unavailableqr') {
		return props.children;
	}

	// default : return to login page with redirect url
	return (
		<Redirect
			to={{
				pathname: '/',
				search: `?redirectTo=${location.pathname}${location.search ?? ''}`
			}}
		/>
	);
};
